import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

import DownIcon from './down.svg?react';

export const Wrapper = styled.button`
    ${styledReset.button}

    color: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.24px;
    text-transform: uppercase;

    display: flex;
    align-items: center;
    gap: 12px;
    user-select: none;

    transition: color 0.2s ease-in-out;

    &:hover {
        color: #fff;
    }

    .yat-checkbox {
        pointer-events: none;
    }
`;

export const SortIcon = styled(DownIcon)<{ $sort: 'asc' | 'desc' }>`
    transform: ${({ $sort }) => ($sort === 'desc' ? 'scaleY(1)' : 'scaleY(-1)')};
    transition: transform 0.2s ease-in-out;
    margin-left: -6px;
`;
